// extracted by mini-css-extract-plugin
export default {"posts-container":"PostsContainer_posts-container__R0tMI","posts-container__inner":"PostsContainer_posts-container__inner__-5ajF"};